import { ColumnLayout, FormField, Input } from '@amzn/awsui-components-console';
import type { CodeReviewState, FieldErrors } from './evaluationSubjects';

interface Props {
  value: CodeReviewState;
  onChange: (patch: Partial<CodeReviewState>) => void;
  errors: FieldErrors;
}

export function CodeReviewFields({ value, onChange, errors }: Props) {
  return (
    <ColumnLayout columns={2}>
      <FormField
        label="Code review ID"
        description="The CR number from the code review URL, e.g. code.amazon.com/reviews/CR-123456789."
        constraintText="Required. Format CR- followed by digits."
        errorText={errors.crId}
      >
        <Input
          value={value.crId}
          onChange={({ detail }) => onChange({ crId: detail.value })}
          placeholder="CR-123456789"
        />
      </FormField>
      <FormField
        label="Revision"
        description="Which revision of the CR to evaluate. Leave blank to use the latest."
        constraintText="Optional. A whole number of 1 or more."
        errorText={errors.revisionId}
      >
        <Input
          value={value.revisionId}
          onChange={({ detail }) => onChange({ revisionId: detail.value })}
          inputMode="numeric"
          placeholder="Latest"
        />
      </FormField>
    </ColumnLayout>
  );
}
